import { FC, useEffect, useState } from "react"
import {
  Box,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Container,
} from "@mui/material"
import {
  useAppDispatch,
  useAppSelector,
  useDeepEffect,
} from "../../../core/app/hooks"
import { useParams,useSearchParams } from "react-router-dom"
import { RootState } from "../../../core/app/store"
import { updateCustomization } from "../../../core/app/slices/order/orderSlice"
import WasmCanves from "../../../components/WasmView/wasmCanves"
import Zoom from "../../../components/Zoom/zoom"
import { ULoading, UText } from "../../../ui-component"
import { fetchClinicalSettings } from "@/core/app/slices/user/userApis"
import { getMaterialsAPI } from "@/core/app/slices/order/orderThunkApi"
import { isEmpty } from "lodash"
import {
  wasmModule,
  preview,
  initScanViewPurely,
  viewControlInTreatment,
  caseManagement,
  EArchType,
  EShowArchType,
  toothMovement,
  viewEdit,
  orderView,
} from "@/gluelayer"
import {
  orderStageInitialize,
} from "../../../core/app/slices/clinical/clinicalworkflow"
import {FastRetainerMode,checkFastRetainerMode} from "../Customization/common"

/**
 * this component is for fastretainer
 * @returns
 */
const CustomizationForFastRetainer: FC<any> = () => {
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const { caseId, patientId } = useParams()
  const [archShowStatus, setArchShowStatus] = useState(EShowArchType.BothArch)

  const [wasmReady, setwasmReady] = useState(false)
  const [zoomValue, setzoomValue] = useState(1)

  const [selectedTeethid, setselectedTeethid] = useState([])
  const [radioRight, setradioRight] = useState(["1", "1"])
  const [radioLeft, setradioLeft] = useState(["1", "1"])

  // set material
  const [material, setmaterial] = useState({
    zendura: [],
    reva: [],
  })
  const [selectedMaterial, setselectedMaterial] = useState("")
  const [isBiteramp, setisBiteramp] = useState(false)

  const {
    orderService: {
      alignerOrderPayload: { coverage, materials },
    },
  } = useAppSelector((state: RootState) => state)
    const { clinicalSettingsFetchStatus } = useAppSelector(
      (state: RootState) => state.userService,
    )

  const fastRetainerMode: FastRetainerMode = checkFastRetainerMode(searchParams)

  const drawCoverageModel = async () => {

    // init the preview view
    // init scan view
    const canvas = document.getElementById("canvas") as HTMLCanvasElement
    if (!canvas) {
      console.error("Customization Canvas element not found!", canvas)
      return
    }

    // init preview
    await initScanViewPurely(canvas)

    // draw models
    await preview.drawScanMtc([0.25, 4],fastRetainerMode === 'refinement_uassist'?{
        upperArch:"Setting Data10/refinement/arch_u.mtc",
        lowerArch:"Setting Data10/refinement/arch_l.mtc"}:undefined)
    // set some status.
    const wasmPreviewModule = wasmModule.module.getScanPreviewWin()
    wasmPreviewModule.EnableTeethCoverModule(true)
    preview.setZoomCallback(setzoomValue)
    caseManagement.setBackgroundPic("backgroundvtk.png")
    console.log("openCaseOrSwitchCanvasWithPromise done.")
    setwasmReady(true)
    if (wasmPreviewModule.IsScanViewArchActorExist(EArchType.UpArch)) {
      setArchShowStatus(EShowArchType.UpArch)
    } else {
      setArchShowStatus(EShowArchType.LowArch)
    }
  }

  useEffect(() => {
    if (!wasmReady) return
    preview.changeArchMode(
    archShowStatus === EShowArchType.UpArch
        ? "up"
        : archShowStatus === EShowArchType.LowArch
        ? "low"
        : "both",
    )
    wasmModule.module
      .getScanPreviewWin()
      .UpdateTeethCoverToOcclusionView(
        archShowStatus === EShowArchType.UpArch ? 0 : 1,
      )
  }, [archShowStatus])

  useEffect(() => {
    if (!wasmReady) return
    preview.zoomWithValue(zoomValue)
  }, [zoomValue])

  useEffect(() => {
  if (!clinicalSettingsFetchStatus) dispatch(fetchClinicalSettings())
    dispatch(getMaterialsAPI({ patientId, caseId }))
    drawCoverageModel()

    if (!isEmpty(coverage)) {
      if (coverage?.keepRamp) {
        setisBiteramp(true)
      }
      const {
        radioLeft = ["1", "1"],
        radioRight = ["1", "1"],
        material,
      } = coverage as any
      setradioLeft(radioLeft)
      setradioRight(radioRight)
      setselectedMaterial(material)
    }

    return () => {
      wasmModule.module.getScanPreviewWin().SaveTeethCoverInfo()
    }
  }, [])

  useEffect(() => {
    if (materials.retainer.length > 0) {
      const zendura = []
      const reva = []

      materials.retainer.map(({ name, thickness }) => {
        if (name === "zendura") {
          zendura.push(thickness / 1000)
        }
        if (name === "reva") {
          reva.push(thickness / 1000)
        }
      })

      setmaterial({ zendura, reva })
      if (coverage?.material) return
      if (!isEmpty(zendura)) setselectedMaterial(zendura[0])
      else setselectedMaterial("reva")
    }
  }, [materials])

  useDeepEffect(() => {
    // if (!wasmReady) return
    dispatch(
      updateCustomization({
        coverage: {
          coverageTooth: [],
          selectedTeethid: [],
          radioLeft,
          radioRight,
          material: selectedMaterial,
          keepRamp: isBiteramp,
        },
      }),
    )
  }, [selectedTeethid, radioLeft, radioRight, selectedMaterial, isBiteramp])
  // cutting line data
  const {
    userService: {
      clinicalSettings: { CuttingLineCC, CuttingLineCP, CuttingLineOffset },
    },
  } = useAppSelector((state: RootState) => state)
  // Generate CuttinglineSetting.json file and put it in the specified directory of wasm.
  useEffect(() => {
    if (!wasmReady) return
    const cuttingObj = {
      Anterior: CuttingLineCC === 0 ? 1 : 0,
      "Offset Control": CuttingLineOffset === 0 ? 1 : 0,
      Posterior: CuttingLineCP === 0 ? 1 : 0,
    }
    console.log("cuttingObj:", cuttingObj)
    caseManagement
      .saveJsonDataToZip(
        JSON.stringify(cuttingObj),
        "CuttinglineSetting.json",
        "Setting Data2",
      )
      .then((bool) => {
        if (bool) {
          console.log(
            "CuttinglineSetting.json has been successfully deposited to the virtual directory!",
          )
        } else {
          console.log(
            "Failed to store CuttinglineSetting.json to virtual directory!",
          )
        }
      })
  }, [CuttingLineCC, CuttingLineCP, CuttingLineOffset, wasmReady])
  const MaterialComponent = () => {
    return (
      (material.reva.length > 0 || material.zendura.length > 0) && (
        <Box id="material">
          <Box sx={{ marginTop: 2, marginBottom: 2 }}>
            <Box sx={{ marginTop: 2, marginBottom: 2 }}>
              <UText variant={"h6"}>Material</UText>
            </Box>
            {material.reva.length > 0 && material.zendura.length > 0 && (
              <>
                <UText variant={"subtitle2"}>
                  Choose material for your order
                </UText>
                <Container sx={{ padding: 2 }}>
                  <RadioGroup
                    value={coverage?.material}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      if (event.target.value === "reva") {
                        setselectedMaterial(
                          (event.target as HTMLInputElement).value,
                        )
                      } else {
                        setselectedMaterial(material.zendura[0])
                      }
                    }}
                  >
                    <FormControlLabel
                      value={material.zendura[0]}
                      control={<Radio />}
                      label={"Zendura"}
                    />

                    {/* {selectedMaterial !== "reva" && (
                <RadioGroup
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setselectedMaterial(
                      (event.target as HTMLInputElement).value,
                    )
                  }}
                  sx={{ padding: "0 42px" }}
                  defaultValue={material.zendura[0]}
                >
                  <FormLabel>Select thickness of retainers</FormLabel>
                  {material.zendura &&
                    material.zendura.map((item, index) => {
                      return (
                        <FormControlLabel
                          key={index}
                          value={item}
                          control={<Radio />}
                          label={item + "”"}
                        />
                      )
                    })}
                </RadioGroup>
              )} */}

                    <FormControlLabel
                      value={"reva"}
                      control={<Radio />}
                      label={"Reva"}
                    />
                  </RadioGroup>
                </Container>
              </>
            )}
            {material.reva.length > 0 && material.zendura.length === 0 && (
              <UText variant={"subtitle2"}>
                Your order will be made in Reva
              </UText>
            )}
            {material.reva.length === 0 && material.zendura.length && (
              <UText variant={"subtitle2"}>
                Your order will be made in Zendura
              </UText>
            )}
          </Box>
        </Box>
      )
    )
  }

  return (
    <Box
      sx={{
        width: "100%",
        padding: "26px 100px 66px",
        marginTop: "18px",
        marginBottom: "50px",
        background: "#FFF",
        borderRadius: 2,
      }}
    >
      <Box sx={{ marginTop: 2, marginBottom: 2 }}>
        <UText variant={"h6"}>Coverage</UText>
        <Box sx={{ marginTop: 2, marginBottom: 2 }}>
          <UText variant={"subtitle2"}>
            Choose the terminal teeth that you want to cover:
          </UText>
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box id="left" sx={{ minWidth: 220 }}>
          <FormLabel id="demo-error-radios">
            Terminal tooth coverage (Right)
          </FormLabel>
          <RadioGroup
            value={
              archShowStatus === EShowArchType.UpArch
                ? radioRight[0]
                : radioRight[1]
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const res = [...radioRight]
              if (archShowStatus === EShowArchType.UpArch) {
                res[0] = (event.target as HTMLInputElement).value
              } else {
                res[1] = (event.target as HTMLInputElement).value
              }
              setradioRight([...res])
            }}
          >
            <FormControlLabel
              sx={{ marginLeft: "125px" }}
              value="1"
              control={<Radio />}
              label="Full"
            />
            <FormControlLabel
              sx={{ marginLeft: "125px" }}
              value="0.75"
              control={<Radio />}
              label="3/4"
            />
            <FormControlLabel
              sx={{ marginLeft: "125px" }}
              value="0.5"
              control={<Radio />}
              label="1/2"
            />
            <FormControlLabel
              sx={{ marginLeft: "125px" }}
              value="0.25"
              control={<Radio />}
              label="1/4"
            />
          </RadioGroup>
        </Box>
        <Box
          id="tooth-view"
          sx={{
            height: 380,
            width: "100%",
            padding: "10px",
          }}
        >
          <Box
            sx={{
              position: "relative",
              height: "100%",
              width: "100%",
              background: "#455A64",
            }}
          >
            <Zoom
              setisUpper={(isUpper: boolean) => {
                setArchShowStatus(
                  isUpper ? EShowArchType.UpArch : EShowArchType.LowArch,
                )
              }}
              setzoomValue={setzoomValue}
              setisLower={(isLower: boolean) => {
                setArchShowStatus(
                  isLower ? EShowArchType.LowArch : EShowArchType.UpArch,
                )
              }}
              zoomValue={zoomValue}
              isUpper={archShowStatus === EShowArchType.UpArch}
              isLower={archShowStatus === EShowArchType.LowArch}
            ></Zoom>
            <WasmCanves
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                left: "0",
                top: "0",
              }}
            />
          </Box>
        </Box>
        <Box id="right" sx={{ minWidth: 220 }}>
          <FormLabel id="demo-error-radios">
            Terminal tooth coverage (Left)
          </FormLabel>
          <RadioGroup
            value={
              archShowStatus === EShowArchType.UpArch
                ? radioLeft[0]
                : radioLeft[1]
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const res = [...radioLeft]
              if (archShowStatus === EShowArchType.UpArch) {
                res[0] = (event.target as HTMLInputElement).value
              } else {
                res[1] = (event.target as HTMLInputElement).value
              }
              setradioLeft([...res])
            }}
          >
            <FormControlLabel value="1" control={<Radio />} label="Full" />
            <FormControlLabel value="0.75" control={<Radio />} label="3/4" />
            <FormControlLabel value="0.5" control={<Radio />} label="1/2" />
            <FormControlLabel value="0.25" control={<Radio />} label="1/4" />
          </RadioGroup>
        </Box>
      </Box>
      {MaterialComponent()}
    </Box>
  )
}

export default CustomizationForFastRetainer
